/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

// Workflow Step Type Constants (matching WfStepTypeConstants.jsx)
export const WF_STEP_TYPE = {
  NOT_DEFINED: 'NOT_DEFINED',
  USE_INITIATOR: 'USE_INITIATOR',
  SETUP_WITH_WORKFLOW: 'SETUP_WITH_WORKFLOW',
  USE_PREDEFINED: 'USE_PREDEFINED'
} as const

export type WfStepType = (typeof WF_STEP_TYPE)[keyof typeof WF_STEP_TYPE]

// Processing Type Constants
export const WF_STEP_PROCESSING_TYPE = {
  SERIAL: 'SERIAL',
  PARALLEL: 'PARALLEL',
  N_OF_ALL: 'N_OF_ALL'
} as const

export type WfStepProcessingType = (typeof WF_STEP_PROCESSING_TYPE)[keyof typeof WF_STEP_PROCESSING_TYPE]

// Read Acknowledgement Action Type Constants
export const RA_ACTION_TYPE = {
  FOR_NOBODY: 'FOR_NOBODY',
  FOR_NEW_USERS_ONLY: 'FOR_NEW_USERS_ONLY',
  FOR_ALL_USERS: 'FOR_ALL_USERS'
} as const

export type RaActionType = (typeof RA_ACTION_TYPE)[keyof typeof RA_ACTION_TYPE]

// Approval Action Type Constants
export const APPROVAL_ACTION_TYPE = {
  NOTIFY: 'NOTIFY',
  NOTIFY_EXTERNAL_SYSTEM: 'NOTIFY_EXTERNAL', // Matches legacy value
  SET_PROPERTY: 'SET_PROPERTY',
  COPY: 'COPY',
  MOVE: 'MOVE'
} as const

export type ApprovalActionType = (typeof APPROVAL_ACTION_TYPE)[keyof typeof APPROVAL_ACTION_TYPE]
